import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import React from 'react';
import styled from 'styled-components';

export const ChevronIcon = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 14px;
`;

export const UpIcon = styled(ChevronUpIcon)`
  transform: translateY(2px);
`;

export const DownIcon = styled(ChevronDownIcon)`
  transform: translateY(-2px);
`;

export type SelectOptionType = {
  value: string;
  label?: string;
  id: string;
};

type SelectProps = {
  options: SelectOptionType[];
  className?: string;
  selectProps?: Record<string, any>;
  placeholderLabel?: string;
};

export const Select = ({
  options,
  className,
  selectProps,
  placeholderLabel,
}: SelectProps) => (
  <Wrapper className={className}>
    <StyledSelect {...selectProps}>
      {placeholderLabel ? (
        <StyledOption value="" disabled hidden>
          {placeholderLabel}
        </StyledOption>
      ) : null}
      {options.map(({ id, value, label }) => (
        <StyledOption key={id} value={value}>
          {label ?? value}
        </StyledOption>
      ))}
    </StyledSelect>
    <StyledChevron>
      <UpIcon />
      <DownIcon />
    </StyledChevron>
  </Wrapper>
);

const Wrapper = styled.div`
  position: relative;
`;

const StyledSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.grayDark2};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  width: 100%;
  appearance: none;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

const StyledOption = styled.option`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

const StyledChevron = styled(ChevronIcon)`
  width: 14px;
  height: 27px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.grayLight3};
`;

export default Select;
